var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { gql } from '@apollo/client';
import { ShiftOpportunityType } from '@amzn/atoz-shiftapp-types';
import { useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { QuickLinks } from './QuickLinks';
export var QuickLinksFeature = function (_a) {
    var opportunityCounts = _a.opportunityCounts, learnHubTrainingCount = _a.learnHubTrainingCount;
    var _b = useState(0), persistedFindShiftsOpportunityCount = _b[0], setPersistedFindShiftsOpportunityCount = _b[1];
    var _c = useState(0), persistedVtoOpportunityCount = _c[0], setPersistedVtoOpportunityCount = _c[1];
    var _d = useAssociateContext(), _e = _d.associateInfo, employeeId = _e.employeeId, siteId = _e.siteId, features = _d.features;
    // Generate default type-to-count mapping
    var defaultOpportunityCountsByType = Object.values(ShiftOpportunityType).reduce(function (total, type) {
        var _a;
        return (__assign(__assign({}, total), (_a = {}, _a[type] = 0, _a)));
    }, {});
    // Update type-to-count mapping with real counts
    var opportunityCountsByType = opportunityCounts.reduce(function (total, current) {
        var _a;
        return (__assign(__assign({}, total), (_a = {}, _a[current.type] = current.count + total[current.type], _a)));
    }, defaultOpportunityCountsByType);
    var findShiftOpportunityCount = opportunityCountsByType[ShiftOpportunityType.Add] +
        opportunityCountsByType[ShiftOpportunityType.VoluntaryExtraTime];
    var vtoOpportunityCount = opportunityCountsByType[ShiftOpportunityType.VoluntaryTimeOff];
    useEffect(function () {
        if (findShiftOpportunityCount) {
            setPersistedFindShiftsOpportunityCount(findShiftOpportunityCount);
        }
        if (vtoOpportunityCount) {
            setPersistedVtoOpportunityCount(vtoOpportunityCount);
        }
    }, [findShiftOpportunityCount, vtoOpportunityCount]);
    return (React.createElement(QuickLinks, { features: features, findShiftOpportunityCount: persistedFindShiftsOpportunityCount, vtoOpportunityCount: persistedVtoOpportunityCount, siteId: siteId, employeeId: employeeId, learnHubTrainingCount: learnHubTrainingCount }));
};
QuickLinksFeature.fragments = {
    shiftOpportunityCount: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment QuickLinks_ShiftOpportunities on OpportunityDailyCount {\n            count\n            type\n        }\n    "], ["\n        fragment QuickLinks_ShiftOpportunities on OpportunityDailyCount {\n            count\n            type\n        }\n    "])))
};
var templateObject_1;
